
import { defineComponent } from 'vue'
import RepoDetailMixin from '~/mixins/repoDetailMixin'

export default defineComponent({
  name: 'RepoTimeout',
  mixins: [RepoDetailMixin],
  props: {
    activateAnalysisLoading: {
      type: Boolean,
      default: false
    }
  }
})
